
import { defineComponent, ref } from "vue";
import { useStore } from "@/store";
import { emptyProject, PortfolioProject } from "@/scripts/portfolio";
import PortfolioNavigation from "@/components/PortfolioNavigation.vue";
import PortfolioProjectCovers from "@/components/PortfolioProjectCovers.vue";
import PortfolioBackground from "@/components/PortfolioBackground.vue";
import ProjectGallery from "@/components/ProjectGallery.vue";
import AboutLink from "@/components/AboutLink.vue";
import SiteTitle from "@/components/SiteTitle.vue";

//
// Page component
//
export default defineComponent({
  name: "Portfolio",
  components: {
    SiteTitle,
    AboutLink,
    ProjectGallery,
    PortfolioBackground,
    PortfolioProjectCovers,
    PortfolioNavigation
  },
  setup() {
    // Get store
    const store = useStore();

    // is wheel enabled on side menu
    const galleryProject = ref<PortfolioProject>(emptyProject);
    const isShowGallery = ref<boolean>(false);
    const isNavigationEnabled = ref<boolean>(true);
    //const siteTitleRef = ref<HTMLElement>();

    // Project viewer
    const showProject = (selectedProject: PortfolioProject) => {
      galleryProject.value = selectedProject;
      isShowGallery.value = true;
      isNavigationEnabled.value = false;
    };

    const closeProject = () => {
      isShowGallery.value = false;
      isNavigationEnabled.value = true;
    };

    return {
      get mediaType() {
        return store.state.mediaType;
      },
      isNavigationEnabled,
      galleryProject,
      isShowGallery,
      showProject,
      closeProject
    };
  }
});
